import React from "react";
import { Link } from 'react-router-dom';
import BixianLogo from '../assets/logos/BixianLogo.png'
export default function Footer(){
    return(
        <div className="footer">
            <div className='footer-body'>
                <div className="upper-footer">
                    <img src={BixianLogo} alt="logo" className="footer-logo"></img>
                    <ul className="nav">
                        <li className="items"><Link className="link" to="/">Home</Link></li>
                        <li className="items"><Link className="link" to="/services">Services</Link></li>
                        <li className="items"><Link className="link" to="/blog">Blog</Link></li>
                        <li className="items"><Link className="link" to="/about">About Us</Link></li>
                        <li className="items"><Link className="link" to="/contact">Contact Us</Link></li>
                        <li className="items"><Link className="link" to="/careers">Careers</Link></li>
                        <li className="items"><Link className="link" to="/privacypolicy">Privacy Policy</Link></li>
                        <li className="items"><Link className="link" to="/disclaimer">Disclaimer</Link></li>
                    </ul>
                    <ul className="others">
                    </ul>
                </div>
                <hr></hr>
                <div className="lower-footer">
                    <p>© 2024 Bixian Performance Marketing Private Limited. All rights reserved.</p>
                </div>
            </div>
        </div>
    )
}